import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HelisaQuery } from '../model/helisa-query';
import { HelisaStageQuery } from '../model/helisa-stage-query';
import {
  HttpHelisaClientService,
  OptionsHttpHelisa,
} from './http-helisa-client.service';

@Injectable({ providedIn: 'root' })
export class HelisaQueryPostgreSqlService {
  private httpClient: HttpHelisaClientService = inject(HttpHelisaClientService);

  get<T>(
    service: string,
    url: string,
    options?: OptionsHttpHelisa
  ): Observable<T[]> {
    return this.httpClient.get<T>(service, url, options);
  }

  getObject<T>(
    service: string,
    url: string,
    options?: OptionsHttpHelisa
  ): Observable<T> {
    return this.httpClient.getObject<T>(service, url, options);
  }

  getQueryObject<T>(
    service: string,
    url: string,
    view: string,
    stageQuery?: HelisaStageQuery,
    page?: number,
    size?: number
  ): Observable<T> {
    return this.httpClient.postQueryObject<T>(
      service,
      url + '/' + view,
      stageQuery ? stageQuery.build(page, size) : new HelisaQuery().build()
    );
  }

  getServiceWithAuth<T>(service: string, url: string): Observable<T> {
    return this.httpClient.getObject<T>(service, url);
  }

  // tslint:disable-next-line:no-any
  postObject<T>(service: string, url: string, body: any): Observable<T> {
    return this.httpClient.postQueryObject<T>(service, url, body);
  }

  deleteServiceWithAuth<T>(service: string, url: string): Observable<T> {
    return this.httpClient.delete<T>(service, url);
  }
}
